import { Injectable } from '@angular/core';
import { HttpService, MainUserService } from '../app-shared';
import { Observable } from 'rxjs';
import { EquipmentModel, EquipmentRequestData, EquipmentSupOutModel } from './equipment.model';

@Injectable()
export class EquipmentService {
  constructor(
    private http: HttpService,
    private mainUserService: MainUserService
  ) {}

  getEquipmentByOutlet(): Observable<Array<EquipmentSupOutModel>> {
    const userId = this.mainUserService.getUserData().userId;
    return this.http.get(`getEquipmentAccessibleByUser?userId=${userId}`);
  }
}
